import React, { useEffect, useContext, useState } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Card,
  CardBody,
  Button,
} from 'reactstrap'
import { GeneralContext } from '../../../context/'
import ApiService from '../../../data/services/ApiService'

const SharePage = (props) => {
  const generalContext = useContext(GeneralContext)
  const { setLoading } = generalContext

  const [store, setStore] = useState({})
  const [domain, setDomain] = useState('')

  useEffect(() => {
    (async () => {
      await fetchStore()
    })()

    async function fetchStore() {
      setLoading(true)
      const response = await ApiService.getStoreByUser()
      setStore(response.data.data)
      setDomain(response.data.domain)
      setLoading(false)
    }
  }, []) // eslint-disable-line

  const share = () => {
    const shareText = `¡Hola!+Te+cuento+que+lancé+mi+propio+emprendimiento+digital+y+estoy+vendiendo+productos+
      súper+padres+de+varias+categorías.+Te+agradezco+un+montón+si+me+apoyas+en+esa+nueva+aventura+🤗❤️+
      Estas+son+las+categorías+que+tengo+-+¿Algo+te+interesa?+%0D%0A+%0D%0A+💄+Belleza+y+cuidado+personal+
      %0D%0A+👶🏻+Bebé+y+niños+%0D%0A+💍+Accesorios+%0D%0A+🏠+Hogar+y+cocina+%0D%0A+%0D%0A+https://${store.url}.${domain}`
    window.open(`https://api.whatsapp.com/send?&text=${shareText}`)
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          ¡Felicidades! Has creado tu tienda, ¿estás lista para compartirla?
          <br /><br />
          Envia un mensaje a tus potenciales clientes contandoles sobre tu nuevo emprendimiento.
          <br /><br />
          <div style={{ textAlign: 'left' }}>
            <Button
              onClick={ share } 
              target={`_blank`}
              className={`btn btn-whatsapp waves-effect waves-light mb-2 mr-2`}
            >
              <i className="bx bxl-whatsapp"></i> Enviar mensaje
            </Button>
            <Button
              color="primary"
              onClick={() => props.history.push(`/mi-tienda/${store.id}/productos/modificar`)}
              className="btn btn-primary waves-effect waves-light mb-2 mr-2"
            >
              <i className={`mdi mdi-plus`}></i> Modificar productos
            </Button>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default withRouter(SharePage)
